/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CitiesRequest } from '../../models/cities-request';
import { CitiesResponse } from '../../models/cities-response';

export interface GetCities$Params {
      body?: CitiesRequest
}

export function getCities(http: HttpClient, rootUrl: string, params?: GetCities$Params, context?: HttpContext): Observable<StrictHttpResponse<CitiesResponse>> {
  const rb = new RequestBuilder(rootUrl, getCities.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CitiesResponse>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getCities.PATH = '/api/advancedsearch/getcities';
getCities.METHOD = 'post';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getCities.ROOTURL = '/portal';
